import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { isLocatable } from '@/models/info.model';
import { UserLabel } from '@/models/label.model';
import { User } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserLabels',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  setup(__props) {



const store = useStore<ShiftCMSState & { us: UsersState }>();

const labels = computed<UserLabel[]>(() => store.state.us.userLabels);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (
      __props.user.id !== -1 &&
      (labels.value.length || (__props.user.address && _unref(isLocatable)(__props.user.address)))
    )
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Information")
            ])),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (__props.user.language)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    color: "info",
                    class: "mr-2",
                    title: `User is using '${__props.user.language.toUpperCase()}' as their app language`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.user.language.toUpperCase()), 1)
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (__props.user.address && _unref(isLocatable)(__props.user.address))
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 1,
                    color: "info",
                    class: "mr-2",
                    title: `${__props.user.address.postal_code} ${__props.user.address.city}`
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Has address")
                    ])),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value, (label) => {
                return (_openBlock(), _createBlock(_component_v_chip, {
                  key: label.id,
                  color: "info",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(label.value), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})